var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { reportUrl } from '@tencent/smp-tools';
import classnames from 'classnames';
import { getDeviceStyle } from '../tool/css';
import { StatAction } from '../common/constants';
var UImage = /** @class */ (function (_super) {
    __extends(UImage, _super);
    function UImage(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props.ui || {}, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        _this.state = {
            data: data,
            style: getDeviceStyle(style),
        };
        _this.statMap = {};
        return _this;
    }
    UImage.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = nextProps.ui || {}, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        this.setState({
            data: data,
            style: getDeviceStyle(style),
        });
    };
    UImage.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize.bind(this), false);
        this.handleReportScrollAction();
    };
    // 	组件本身有效曝光 -- 曝光到屏幕里面即可
    UImage.prototype.handleMonitorComponentShow = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this.props || {}, stat = _j.stat, _k = _j.ui, ui = _k === void 0 ? {} : _k;
        var needShowScreenTop = Math.abs((_b = (_a = this.compRef) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.y) <
            window.self.innerHeight -
                ((_c = this.compRef) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height) / 2;
        var needShowHeight = Math.abs((_e = (_d = this.compRef) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.y) <
            window.self.innerHeight - 50;
        if (((_g = (_f = this.compRef) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect()) === null || _g === void 0 ? void 0 : _g.y) >= 0 &&
            (needShowScreenTop || needShowHeight)) {
            var subkey = ui.key;
            var isReported = this.statMap["".concat(subkey, "_SHOW")] !== undefined;
            if (!isReported) {
                this.statMap["".concat(subkey, "_SHOW")] = true;
                reportUrl({
                    statUrl: stat || ((_h = window.RENDER_DATA) === null || _h === void 0 ? void 0 : _h.stat),
                    action: 'SHOW',
                    subkey: subkey,
                });
            }
        }
    };
    UImage.prototype.handleReportScrollAction = function () {
        var _this = this;
        this.handleMonitorComponentShow();
        window.addEventListener('scroll', function () {
            _this.handleMonitorComponentShow();
        });
    };
    UImage.prototype.handleComponentReport = function (action) {
        var _a;
        var data = this.state.data;
        var _b = this.props, stat = _b.stat, subkey = _b.subkey, _c = _b.ui, ui = _c === void 0 ? { key: 'UImage' } : _c;
        stat &&
            reportUrl({
                statUrl: stat || ((_a = window.RENDER_DATA) === null || _a === void 0 ? void 0 : _a.stat),
                action: action,
                subkey: data.id ? "c_".concat(data.id) : subkey || ui.key || 'UImage',
            });
    };
    UImage.prototype.handleResize = function () {
        var style = this.props.ui.style;
        var deviceStyle = getDeviceStyle(style);
        this.setState({
            style: deviceStyle,
        });
    };
    UImage.prototype.handleClick = function () {
        var onClick = this.props.onClick;
        this.handleComponentReport(StatAction.COMPONENT_CLICK);
        onClick && onClick();
    };
    UImage.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, _b = _a.style.image, imageStyle = _b === void 0 ? {} : _b;
        var _c = this.props, defaultSrc = _c.defaultSrc, _d = _c.className, className = _d === void 0 ? '' : _d, id = _c.id, _e = _c.ui, ui = _e === void 0 ? {} : _e;
        var restAttrs = { id: id, 'data-smp': ui.key };
        var innerWidth = window.self.innerWidth;
        return (React.createElement("img", __assign({ className: classnames(className, 'smp-ui-uimage'), ref: function (ref) {
                _this.compRef = ref;
            }, onClick: this.handleClick.bind(this), style: imageStyle, width: (imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.width) || innerWidth, height: imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.height, loading: "lazy", src: data.image || defaultSrc }, restAttrs)));
    };
    return UImage;
}(React.PureComponent));
export default UImage;
